'use client';

import dynamic from 'next/dynamic';
import { useEffect } from 'react';

const BuilderPreviewPage = dynamic(
  () => import('@/components/sections/builder/preview-page').then((mod) => mod.default),
  { ssr: false }
);

export function ClientProductDetailPreview({
  slug,
  isPreview,
  themeId,
}: {
  slug: string;
  isPreview: boolean;
  themeId: string;
}) {
  useEffect(() => {
    window.parent?.postMessage(
      {
        type: 'iframe_loaded',
        previewPath: 'product_detail',
        themeId: themeId,
        slug: `products/${slug}`,
      },
      '*'
    );
  }, [slug]);

  if (!isPreview) return null;

  return <BuilderPreviewPage groupBody='body,body_product_detail' />;
}
